import { useState, useEffect } from "react";

// Partner brand logo with a guaranteed, never-broken fallback. Tries the supplied logo URL
// (a real favicon/logo); if it is missing or fails to load, renders a clean coloured monogram
// chip (brand initial on a brand-tinted background) instead of a blank/grey box.
const TINTS = [
  "bg-sky-100 text-sky-700",
  "bg-emerald-100 text-emerald-700",
  "bg-violet-100 text-violet-700",
  "bg-amber-100 text-amber-700",
  "bg-rose-100 text-rose-700",
  "bg-indigo-100 text-indigo-700",
  "bg-teal-100 text-teal-700",
  "bg-fuchsia-100 text-fuchsia-700",
];

export const BrandLogo = ({ name = "", logo = "", size = 24, rounded = "rounded", className = "", testid }) => {
  const [failed, setFailed] = useState(!logo);
  useEffect(() => { setFailed(!logo); }, [logo]);
  const initial = (name || "?").trim().charAt(0).toUpperCase() || "•";
  const tint = TINTS[(name.charCodeAt(0) || 0) % TINTS.length];
  const dim = { height: size, width: size };
  if (failed || !logo) {
    return (
      <span style={dim} data-testid={testid} className={`flex shrink-0 items-center justify-center ${rounded} text-[10px] font-bold ${tint} ${className}`}>
        {initial}
      </span>
    );
  }
  return (
    <span style={dim} className={`flex shrink-0 items-center justify-center overflow-hidden ${rounded} bg-white ring-1 ring-slate-100 ${className}`}>
      <img src={logo} alt={name} data-testid={testid} onError={() => setFailed(true)} className="h-[72%] w-[72%] object-contain" />
    </span>
  );
};

export default BrandLogo;
